import { render, staticRenderFns } from "./BetgameDescription.vue?vue&type=template&id=65b374a4&scoped=true"
import script from "./BetgameDescription.vue?vue&type=script&lang=js"
export * from "./BetgameDescription.vue?vue&type=script&lang=js"
import style0 from "./BetgameDescription.vue?vue&type=style&index=0&id=65b374a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b374a4",
  null
  
)

export default component.exports